var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeoSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460.14 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-12,.cls-3{fill:#d6d8e5;}.cls-1{opacity:0.4;}.cls-2{fill:#b1b4c4;}.cls-4{fill:#9ea1af;}.cls-5{fill:#e4e7f2;}.cls-6{fill:#fff;}.cls-7{fill:#e9eaf2;}.cls-8{fill:#dadce5;}.cls-9{opacity:0.05;}.cls-10{fill:#f5f7fc;}.cls-11{fill:#f9cb07;}.cls-12{opacity:0.3;}.cls-13{fill:#dd990e;}.cls-14{fill:#cc8b09;}.cls-15{fill:#e8a30a;}.cls-16{fill:#f9ca06;}.cls-17{fill:#d33d3d;}.cls-18{fill:#f4f4f4;}.cls-19{fill:#ff4d4d;}.cls-20{fill:#2b303f;}.cls-21{fill:#2f55d4;}.cls-22{fill:#ffcea9;}.cls-23{fill:#1d3892;}.cls-24{fill:#9c73ff;}.cls-25{fill:#2f55d4;}.cls-26{fill:#ededed;}.cls-27{fill:#bfbfbf;}.cls-28{fill:#e5e5e5;}.cls-29,.cls-33{fill:#3e7eff;}.cls-30,.cls-33{opacity:0.1;}.cls-31{opacity:0.15;}.cls-32{fill:#b7e200;}.cls-34{fill:#394051;}.cls-35{fill:#232733;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SEO_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "monitor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.54,350.25l-50.15-29c-3.61-2.08-3.16-5.73,1-8.14l32.48-18.76,63.24,36.51-32.49,18.76C315.47,352.07,309.15,352.33,305.54,350.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310.06,347.59l-50.14-28.95c-3.62-2.09-3.16-5.73,1-8.14l32.49-18.76,63.24,36.51L324.17,347C320,349.42,313.68,349.68,310.06,347.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "356.66 328.25 356.66 326.34 353.74 328.02 356.66 328.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "257.48 315.19 257.48 313.25 260.48 314.49 257.48 315.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M310.06,345.68l-50.14-28.95c-3.62-2.09-3.16-5.74,1-8.15l32.49-18.75,63.24,36.51-32.49,18.75C320,347.5,313.68,347.77,310.06,345.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "293.59 289.91 285.76 263.95 349.69 300.61 356.66 326.34 293.59 289.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M354.8,327.41l1.86-1.07-2.76-2.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "291.57 290.89 283.75 264.92 347.68 301.59 354.8 327.41 291.57 290.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M453.85,371.17,206.4,228.3c-3.47-2-6.28-7.38-6.28-12V24.88c0-4.63,2.81-6.76,6.28-4.75L453.85,163c3.48,2,6.29,7.38,6.29,12V366.42C460.14,371.05,457.33,373.17,453.85,371.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "455.13 373.14 457.87 371.56 456.69 363.43 455.13 373.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.67,21.31l2.7-1.56L206.25,22s-4.13.63-4.23.61S199.67,21.31,199.67,21.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M451.59,372.48,204.13,229.61c-3.47-2-6.28-7.38-6.28-12V26.19c0-4.63,2.81-6.76,6.28-4.75L451.59,164.31c3.47,2,6.28,7.38,6.28,12V367.73C457.87,372.36,455.06,374.48,451.59,372.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M457.44,176.56V368c0,4.64-2.82,6.77-6.29,4.75L203.69,229.86c-3.47-2-6.28-7.38-6.28-12V26.44c0-4.63,2.81-6.75,6.28-4.75L451.15,164.56C454.62,166.56,457.44,171.94,457.44,176.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M454,361.09,200.55,214.74l.14-187.53c0-1.93,1.34-2.7,3-1.74L451.15,168.33a6.67,6.67,0,0,1,3,5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M438.34,198.06,213.65,68.33a6.09,6.09,0,0,1-2.56-4.88V47.23c0-1.88,1.14-2.75,2.56-1.93L438.34,175a6.15,6.15,0,0,1,2.56,4.89v16.22C440.9,198,439.75,198.88,438.34,198.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 221.38,
    cy: 61.21,
    rx: 4.02,
    ry: 6.96,
    transform: "translate(-0.94 118.9) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M338.2,130.8l-19.43-11.23a1.51,1.51,0,0,1-.64-1.22v-2.57c0-.48.28-.69.64-.49l19.43,11.23a1.51,1.51,0,0,1,.64,1.22v2.57C338.84,130.78,338.56,131,338.2,130.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M369.66,149l-19.43-11.22a1.52,1.52,0,0,1-.64-1.22v-2.58c0-.47.28-.69.64-.48l19.43,11.22a1.51,1.51,0,0,1,.64,1.22v2.58C370.3,149,370,149.16,369.66,149Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M400.61,166.83l-19.44-11.22a1.57,1.57,0,0,1-.64-1.23v-2.57c0-.47.29-.69.64-.49l19.44,11.23a1.51,1.51,0,0,1,.64,1.22v2.57C401.25,166.82,401,167,400.61,166.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M432.07,185l-19.44-11.22a1.55,1.55,0,0,1-.64-1.22V170c0-.47.29-.69.64-.48l19.44,11.22a1.53,1.53,0,0,1,.64,1.22v2.58C432.71,185,432.42,185.2,432.07,185Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M421.33,238.33l-52.82-30.5A6.11,6.11,0,0,1,366,203V168.86c0-1.88,1.14-2.74,2.55-1.93l52.82,30.49a6.15,6.15,0,0,1,2.56,4.89v34.08C423.89,238.28,422.74,239.14,421.33,238.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M351.76,249.4,219.27,172.9a3.07,3.07,0,0,1-1.28-2.44v-5.87c0-.94.58-1.37,1.28-1l132.49,76.49a3.05,3.05,0,0,1,1.28,2.44v5.87C353,249.37,352.47,249.8,351.76,249.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M338.72,255.75,219.66,187a3.05,3.05,0,0,1-1.28-2.44v-2.92c0-.94.57-1.38,1.28-1l119.06,68.74a3.08,3.08,0,0,1,1.28,2.44v2.92C340,255.72,339.42,256.16,338.72,255.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M338.72,266.82,219.66,198.09a3.07,3.07,0,0,1-1.28-2.45v-2.92c0-.94.57-1.37,1.28-1l119.06,68.73a3.1,3.1,0,0,1,1.28,2.45v2.92C340,266.8,339.42,267.23,338.72,266.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M308.28,260.33l-88.62-51.17a3.05,3.05,0,0,1-1.28-2.44V203.8c0-.94.57-1.38,1.28-1L308.28,254a3,3,0,0,1,1.28,2.44v2.92C309.56,260.3,309,260.73,308.28,260.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M422.61,252.5l-55.37-32a3.05,3.05,0,0,1-1.28-2.44v-2.92c0-.94.57-1.38,1.28-1l55.37,32a3.06,3.06,0,0,1,1.28,2.45v2.92C423.89,252.48,423.32,252.91,422.61,252.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M422.61,263.58l-55.37-32a3.06,3.06,0,0,1-1.28-2.45v-2.92c0-.94.57-1.37,1.28-1l55.37,32a3.05,3.05,0,0,1,1.28,2.44v2.92C423.89,263.55,423.32,264,422.61,263.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M408.11,266.28l-40.87-23.6a3.05,3.05,0,0,1-1.28-2.44v-2.92c0-.94.57-1.38,1.28-1L408.11,260a3.06,3.06,0,0,1,1.28,2.45v2.91C409.39,266.26,408.82,266.69,408.11,266.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M421.33,323.68l-52.82-30.5A6.11,6.11,0,0,1,366,288.3V254.21c0-1.88,1.14-2.75,2.55-1.93l52.82,30.49a6.15,6.15,0,0,1,2.56,4.89v34.08C423.89,323.63,422.74,324.49,421.33,323.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M422.61,337.85l-55.37-32a3.05,3.05,0,0,1-1.28-2.44v-2.92c0-.94.57-1.38,1.28-1l55.37,32a3.06,3.06,0,0,1,1.28,2.45v2.92C423.89,337.83,423.32,338.26,422.61,337.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "383.92 201.63 380.21 192.08 373.46 201.68 380.87 205.96 386.96 209.48 400.54 217.32 390.71 191.97 383.92 201.63"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 411.28,
    cy: 202.07,
    rx: 3.61,
    ry: 6.26,
    transform: "translate(-45.93 232.72) rotate(-30)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "384.3 288.24 380.6 278.69 373.85 288.29 381.26 292.57 387.35 296.08 400.93 303.92 391.09 278.58 384.3 288.24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 411.66,
    cy: 288.67,
    rx: 3.61,
    ry: 6.26,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -89.18, 244.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M350.23,224.61,221.87,150.87a5.48,5.48,0,0,1-2.3-4.38V86.68c0-1.68,1-2.46,2.3-1.73l128.36,73.74a5.5,5.5,0,0,1,2.29,4.38v59.81C352.52,224.57,351.49,225.35,350.23,224.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "257.53 149.3 251.19 132.97 239.65 149.39 252.32 156.7 262.73 162.71 285.95 176.12 269.13 132.78 257.53 149.3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 327.9,
    cy: 167.05,
    rx: 6.18,
    ry: 10.7,
    transform: "translate(-39.6 186.34) rotate(-30)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M226.48,129v89.6c0,3.34-2,4.88-4.54,3.43L197.41,207.9V106.2l24.53,14.15C224.44,121.8,226.48,125.69,226.48,129Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.06,98.65,127.7,55.14a3,3,0,0,0-2.67-.37h0a2.35,2.35,0,0,0-.57.33l-2.36,1.37,1.1,1.47c0,.2,0,.41,0,.63v89.6c0,3.34,2,7.22,4.54,8.67l73.93,42.69.94,3,3.23-1.81a2.4,2.4,0,0,0,.46-.27h0a4.28,4.28,0,0,0,1.33-3.52V107.33C207.6,104,205.57,100.1,203.06,98.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M199.92,202.13l-75.37-43.51c-2.5-1.45-4.54-5.33-4.54-8.68V60.35c0-3.34,2-4.88,4.54-3.43l75.37,43.51c2.51,1.45,4.54,5.33,4.54,8.68V198.7C204.46,202,202.43,203.58,199.92,202.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "131.82 153.38 133.63 154.43 133.63 74.74 131.82 73.69 131.82 153.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M132.73,111.61h0a7.59,7.59,0,0,1-3.18-6.07V96.19c0-2.34,1.42-3.41,3.18-2.4h0a7.61,7.61,0,0,1,3.17,6.07v9.35C135.9,111.55,134.48,112.63,132.73,111.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "151.26 164.32 153.08 165.37 153.08 85.69 151.26 84.64 151.26 164.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M152.17,148.77h0a7.65,7.65,0,0,1-3.18-6.08v-9.35c0-2.34,1.43-3.41,3.18-2.4h0a7.61,7.61,0,0,1,3.18,6.07v9.35C155.35,148.7,153.93,149.78,152.17,148.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "170.71 175.55 172.53 176.6 172.53 96.91 170.71 95.86 170.71 175.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M171.62,123.3h0a7.61,7.61,0,0,1-3.18-6.07v-9.35c0-2.34,1.42-3.42,3.18-2.41h0a7.65,7.65,0,0,1,3.18,6.08v9.35C174.8,123.24,173.37,124.31,171.62,123.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "190.16 186.78 191.97 187.82 191.97 108.14 190.16 107.09 190.16 186.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M191.07,155.49h0a7.59,7.59,0,0,1-3.18-6.07v-9.35c0-2.34,1.42-3.41,3.18-2.4h0a7.61,7.61,0,0,1,3.17,6.07v9.35C194.24,155.43,192.82,156.51,191.07,155.49Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Coin"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 155.24,
    cy: 285.96,
    rx: 27.8,
    ry: 16.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 162.12,
    cy: 281.83,
    rx: 27.8,
    ry: 16.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "134.33 282.07 134.33 274.76 139.82 279.65 134.33 282.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "189.92 274.95 189.92 281.83 187.11 284.81 185.74 276.94 189.92 274.95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 162.12,
    cy: 274.95,
    rx: 27.8,
    ry: 16.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M182,275.45c-.28,2.7-2.21,5.37-5.79,7.44-7.78,4.48-20.38,4.48-28.15,0-3.59-2.07-5.51-4.74-5.79-7.44-.33-3.16,1.6-6.4,5.79-8.81,7.77-4.49,20.37-4.49,28.15,0C180.39,269.05,182.32,272.29,182,275.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M182,275.45c-.28,2.7-2.21,5.37-5.79,7.44-7.78,4.48-20.38,4.48-28.15,0-3.59-2.07-5.51-4.74-5.79-7.44.28-2.7,2.2-5.37,5.79-7.44,7.77-4.49,20.37-4.49,28.15,0C179.78,270.08,181.71,272.75,182,275.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M161.83,271.69a3.78,3.78,0,0,0-.73.06c-.33,0-.69.11-1.1.2s-.83.19-1.27.32a8.38,8.38,0,0,0-1.24.48l3.19,1.84.58-.2c.81-.27,1.58-.5,2.3-.69a10.62,10.62,0,0,1,2.07-.34,7,7,0,0,1,1.9.13,5.87,5.87,0,0,1,1.82.71,3.59,3.59,0,0,1,1.38,1.21,1.65,1.65,0,0,1,.2,1.25,2.73,2.73,0,0,1-.75,1.23,7.74,7.74,0,0,1-1.46,1.15l2,1.17-1.1.64-2.06-1.18a16.54,16.54,0,0,1-3,1.15,19.42,19.42,0,0,1-3.37.63l-1.07-1.92a7.69,7.69,0,0,0,.9-.07,11.8,11.8,0,0,0,1.34-.23c.49-.1,1-.24,1.56-.4a10.69,10.69,0,0,0,1.56-.58l-3.18-1.83-.41.14-.44.13a21.66,21.66,0,0,1-2.2.62,10,10,0,0,1-1.87.25,6.38,6.38,0,0,1-1.66-.15,5.66,5.66,0,0,1-1.53-.62,4,4,0,0,1-1.33-1.14,2,2,0,0,1-.36-1.24,2.3,2.3,0,0,1,.52-1.24,6,6,0,0,1,1.3-1.17l-1.89-1.09,1.11-.64,1.87,1.08a13.24,13.24,0,0,1,2.74-1,21.1,21.1,0,0,1,2.75-.5ZM156.4,275a2.34,2.34,0,0,0,1.38.3,9.16,9.16,0,0,0,1.91-.43l-3-1.73C155.6,273.9,155.5,274.52,156.4,275Zm10.49.87a2.36,2.36,0,0,0-1.49-.26,11.14,11.14,0,0,0-2.09.46l3,1.71C167.55,277.05,167.75,276.41,166.89,275.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M160.11,279.53c0-.08,0-1.08,0-1.08l1.22.79-.53.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "170.75 280.21 170.75 279.13 168.11 279.34 169.63 280.37 170.75 280.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "170.98 276.26 170.98 275.17 169 275.88 170.98 276.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M162.78,276.2l.66-.63,2.32,1.6-.14.48s-1.74-.73-1.8-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M156.7,272.8l3.08,1.75.63-.46s-.38-.44-.41-.49a4.31,4.31,0,0,0-1-.8c-.23,0-1.69-.7-1.69-.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "161.83 271.69 161.83 270.61 160.41 270.15 160.11 271 160.19 271.38 161.83 271.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "152.42 270.91 152.42 269.83 154.06 270.01 153.53 271.05 152.42 270.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M152.48,274.57v-1.12h1.89l-.46,1-.82.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M161.83,270.61a3.78,3.78,0,0,0-.73.06c-.33.05-.69.11-1.1.2s-.83.19-1.27.32a8.38,8.38,0,0,0-1.24.48l3.19,1.84.58-.2c.81-.27,1.58-.5,2.3-.69a10.62,10.62,0,0,1,2.07-.34,7,7,0,0,1,1.9.13,5.87,5.87,0,0,1,1.82.71,3.59,3.59,0,0,1,1.38,1.21,1.65,1.65,0,0,1,.2,1.25,2.73,2.73,0,0,1-.75,1.23,7.74,7.74,0,0,1-1.46,1.15l2,1.18-1.1.64-2.06-1.19a16.54,16.54,0,0,1-3,1.15,19.42,19.42,0,0,1-3.37.63l-1.07-1.92a7.69,7.69,0,0,0,.9-.07,11.8,11.8,0,0,0,1.34-.23c.49-.1,1-.24,1.56-.4a10.69,10.69,0,0,0,1.56-.58l-3.18-1.83-.41.14-.44.13a21.66,21.66,0,0,1-2.2.62,9.27,9.27,0,0,1-1.87.25,6.38,6.38,0,0,1-1.66-.15,5.66,5.66,0,0,1-1.53-.62,3.86,3.86,0,0,1-1.33-1.14,2,2,0,0,1-.36-1.23,2.32,2.32,0,0,1,.52-1.25,6,6,0,0,1,1.3-1.17l-1.89-1.09,1.11-.64,1.87,1.08a13.84,13.84,0,0,1,2.74-1,19.47,19.47,0,0,1,2.75-.49ZM156.4,274a2.34,2.34,0,0,0,1.38.3,9.16,9.16,0,0,0,1.91-.43l-3-1.73C155.6,272.82,155.5,273.44,156.4,274Zm10.49.88a2.36,2.36,0,0,0-1.49-.27,12,12,0,0,0-2.09.46l3,1.72C167.55,276,167.75,275.33,166.89,274.84Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Coin-2",
    "data-name": "Coin"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 164.39,
    cy: 273.27,
    rx: 27.8,
    ry: 16.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "136.6 273.51 136.6 266.2 142.09 271.09 136.6 273.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "192.19 266.39 192.19 273.27 189.38 276.25 188.01 268.38 192.19 266.39"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 164.39,
    cy: 266.39,
    rx: 27.8,
    ry: 16.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M184.26,266.89c-.28,2.7-2.21,5.37-5.79,7.44-7.78,4.48-20.38,4.48-28.15,0-3.59-2.07-5.51-4.74-5.79-7.44-.33-3.16,1.6-6.4,5.79-8.81,7.77-4.49,20.37-4.49,28.15,0C182.66,260.49,184.59,263.73,184.26,266.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M184.26,266.89c-.28,2.7-2.21,5.37-5.79,7.44-7.78,4.48-20.38,4.48-28.15,0-3.59-2.07-5.51-4.74-5.79-7.44.28-2.7,2.2-5.37,5.79-7.44,7.77-4.49,20.37-4.49,28.15,0C182.05,261.52,184,264.19,184.26,266.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M164.1,263.13a3.78,3.78,0,0,0-.73.06c-.33,0-.69.11-1.1.2s-.83.19-1.26.32a8.1,8.1,0,0,0-1.25.48L163,266l.57-.2c.81-.27,1.58-.5,2.3-.69a10.62,10.62,0,0,1,2.07-.34,7,7,0,0,1,1.9.13,5.87,5.87,0,0,1,1.82.71,3.59,3.59,0,0,1,1.38,1.21,1.6,1.6,0,0,1,.2,1.25,2.73,2.73,0,0,1-.75,1.23,7.74,7.74,0,0,1-1.46,1.15l2,1.17-1.11.64-2-1.18a16.64,16.64,0,0,1-3.05,1.15,19.42,19.42,0,0,1-3.37.63L162.38,271a7.69,7.69,0,0,0,.9-.07,11.44,11.44,0,0,0,1.34-.23c.49-.1,1-.24,1.56-.4a10.69,10.69,0,0,0,1.56-.58l-3.18-1.83-.41.14-.44.13a21.66,21.66,0,0,1-2.2.62,9.27,9.27,0,0,1-1.87.25,6.38,6.38,0,0,1-1.66-.15,5.79,5.79,0,0,1-1.53-.62,4,4,0,0,1-1.33-1.14,2,2,0,0,1-.36-1.23,2.34,2.34,0,0,1,.53-1.25,5.71,5.71,0,0,1,1.29-1.17l-1.88-1.09,1.1-.64,1.87,1.08a13.24,13.24,0,0,1,2.74-1,21.1,21.1,0,0,1,2.75-.5Zm-5.43,3.35a2.34,2.34,0,0,0,1.38.3,9.16,9.16,0,0,0,1.91-.43l-3-1.73C157.87,265.34,157.77,266,158.67,266.48Zm10.49.87a2.33,2.33,0,0,0-1.49-.26,11.14,11.14,0,0,0-2.09.46l3,1.71C169.82,268.49,170,267.85,169.16,267.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M162.38,271c0-.08,0-1.08,0-1.08l1.22.79-.53.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "173.03 271.65 173.03 270.58 170.38 270.78 171.9 271.81 173.03 271.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "173.25 267.7 173.25 266.61 171.27 267.32 173.25 267.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M165.05,267.64l.66-.63,2.32,1.6-.14.48s-1.74-.73-1.79-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M159,264.24l3.09,1.75.63-.46-.42-.48a4.07,4.07,0,0,0-1-.81c-.23,0-1.69-.69-1.69-.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "164.1 263.13 164.1 262.05 162.69 261.59 162.38 262.44 162.46 262.82 164.1 263.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "154.69 262.35 154.69 261.27 156.34 261.45 155.81 262.5 154.69 262.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M154.76,266v-1.12h1.88l-.46,1-.82.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M164.1,262.05a3.78,3.78,0,0,0-.73.06c-.33.05-.69.11-1.1.2s-.83.19-1.26.32a8.1,8.1,0,0,0-1.25.48L163,265l.57-.2c.81-.27,1.58-.5,2.3-.69a10.62,10.62,0,0,1,2.07-.34,7,7,0,0,1,1.9.13,5.87,5.87,0,0,1,1.82.71,3.59,3.59,0,0,1,1.38,1.21,1.61,1.61,0,0,1,.2,1.25,2.73,2.73,0,0,1-.75,1.23A7.35,7.35,0,0,1,171,269.4l2,1.18-1.11.64-2-1.19a16.64,16.64,0,0,1-3.05,1.15,19.42,19.42,0,0,1-3.37.63l-1.07-1.92a7.69,7.69,0,0,0,.9-.07,11.44,11.44,0,0,0,1.34-.23c.49-.1,1-.24,1.56-.4a10.69,10.69,0,0,0,1.56-.58l-3.18-1.83-.41.14-.44.14c-.8.26-1.53.46-2.2.61a10.1,10.1,0,0,1-1.87.26,6.83,6.83,0,0,1-1.66-.16,5.79,5.79,0,0,1-1.53-.62,3.76,3.76,0,0,1-1.33-1.14,2,2,0,0,1-.36-1.23,2.34,2.34,0,0,1,.53-1.25,5.71,5.71,0,0,1,1.29-1.17l-1.88-1.09,1.1-.64,1.87,1.08a13.84,13.84,0,0,1,2.74-1,19.47,19.47,0,0,1,2.75-.49Zm-5.43,3.35a2.34,2.34,0,0,0,1.38.3,8.56,8.56,0,0,0,1.91-.43l-3-1.72C157.87,264.26,157.77,264.88,158.67,265.4Zm10.49.88a2.34,2.34,0,0,0-1.49-.27,12,12,0,0,0-2.09.46l3,1.72C169.82,267.41,170,266.77,169.16,266.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Coin-3",
    "data-name": "Coin"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 162.69,
    cy: 265.03,
    rx: 27.8,
    ry: 16.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "134.89 265.27 134.89 257.96 140.39 262.85 134.89 265.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "190.49 258.15 190.49 265.03 187.68 268.01 186.3 260.14 190.49 258.15"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 162.69,
    cy: 258.15,
    rx: 27.8,
    ry: 16.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M182.55,258.65c-.28,2.7-2.2,5.37-5.79,7.44-7.77,4.48-20.37,4.48-28.15,0-3.58-2.07-5.51-4.74-5.78-7.44-.34-3.16,1.59-6.4,5.78-8.81,7.78-4.49,20.38-4.49,28.15,0C181,252.25,182.88,255.49,182.55,258.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M182.55,258.65c-.28,2.7-2.2,5.37-5.79,7.44-7.77,4.48-20.37,4.48-28.15,0-3.58-2.07-5.51-4.74-5.78-7.44.27-2.7,2.2-5.37,5.78-7.44,7.78-4.49,20.38-4.49,28.15,0C180.35,253.28,182.27,256,182.55,258.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M162.4,254.89a3.73,3.73,0,0,0-.73.06c-.33,0-.7.11-1.1.2s-.83.19-1.27.32a8.51,8.51,0,0,0-1.25.48l3.2,1.84.57-.2c.82-.27,1.58-.5,2.3-.69a10.62,10.62,0,0,1,2.07-.34,7.09,7.09,0,0,1,1.91.13,6,6,0,0,1,1.82.71,3.63,3.63,0,0,1,1.37,1.21,1.65,1.65,0,0,1,.21,1.25,2.92,2.92,0,0,1-.75,1.23,8.07,8.07,0,0,1-1.46,1.15l2,1.17-1.11.64-2.05-1.18a16.37,16.37,0,0,1-3,1.15,19.49,19.49,0,0,1-3.36.63l-1.07-1.92a7.71,7.71,0,0,0,.89-.07,11.44,11.44,0,0,0,1.34-.23c.5-.1,1-.24,1.56-.4a11.27,11.27,0,0,0,1.57-.58l-3.18-1.83-.42.14-.43.13a22.41,22.41,0,0,1-2.2.62,10.14,10.14,0,0,1-1.88.25,6.34,6.34,0,0,1-1.65-.15,5.53,5.53,0,0,1-1.53-.62,4,4,0,0,1-1.33-1.14,1.9,1.9,0,0,1-.37-1.23,2.39,2.39,0,0,1,.53-1.25,5.71,5.71,0,0,1,1.29-1.17L153,254.11l1.11-.64,1.87,1.08a13,13,0,0,1,2.74-1,21,21,0,0,1,2.74-.5ZM157,258.24a2.36,2.36,0,0,0,1.39.3,9.09,9.09,0,0,0,1.9-.43l-3-1.73Q155.61,257.46,157,258.24Zm10.5.87a2.38,2.38,0,0,0-1.5-.26,11.31,11.31,0,0,0-2.09.46l3,1.71C168.12,260.25,168.32,259.61,167.46,259.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M160.68,262.73c0-.08,0-1.08,0-1.08l1.22.79-.53.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "171.32 263.41 171.32 262.33 168.68 262.54 170.19 263.57 171.32 263.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "171.54 259.46 171.54 258.37 169.56 259.08 171.54 259.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M163.34,259.4l.66-.63,2.33,1.6-.15.48s-1.73-.73-1.79-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M157.27,256l3.08,1.75.63-.46-.42-.48a3.87,3.87,0,0,0-1-.81c-.22,0-1.69-.7-1.69-.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "162.4 254.89 162.4 253.81 160.98 253.35 160.68 254.2 160.75 254.58 162.4 254.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "152.99 254.11 152.99 253.03 154.63 253.21 154.1 254.25 152.99 254.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M153.05,257.77v-1.12h1.88l-.46,1-.81.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M162.4,253.81a3.73,3.73,0,0,0-.73.06c-.33,0-.7.11-1.1.2s-.83.19-1.27.32a8.51,8.51,0,0,0-1.25.48l3.2,1.84.57-.2c.82-.27,1.58-.5,2.3-.69a10.62,10.62,0,0,1,2.07-.34,7.09,7.09,0,0,1,1.91.13,6,6,0,0,1,1.82.71,3.63,3.63,0,0,1,1.37,1.21,1.66,1.66,0,0,1,.21,1.25,2.92,2.92,0,0,1-.75,1.23,7.66,7.66,0,0,1-1.46,1.15l2,1.18-1.11.64-2.05-1.19a16.37,16.37,0,0,1-3,1.15,19.49,19.49,0,0,1-3.36.63l-1.07-1.92a7.71,7.71,0,0,0,.89-.07,11.44,11.44,0,0,0,1.34-.23c.5-.1,1-.24,1.56-.4a11.27,11.27,0,0,0,1.57-.58l-3.18-1.83-.42.14-.43.13a22.41,22.41,0,0,1-2.2.62,9.36,9.36,0,0,1-1.88.25,6.34,6.34,0,0,1-1.65-.15,5.53,5.53,0,0,1-1.53-.62,3.86,3.86,0,0,1-1.33-1.14,1.9,1.9,0,0,1-.37-1.23,2.42,2.42,0,0,1,.53-1.25,5.71,5.71,0,0,1,1.29-1.17L153,253l1.11-.64,1.87,1.08a13.61,13.61,0,0,1,2.74-1,19.34,19.34,0,0,1,2.74-.49ZM157,257.16a2.36,2.36,0,0,0,1.39.3,9.09,9.09,0,0,0,1.9-.43l-3-1.73Q155.61,256.38,157,257.16Zm10.5.88a2.38,2.38,0,0,0-1.5-.27,12.2,12.2,0,0,0-2.09.46l3,1.72C168.12,259.17,168.32,258.53,167.46,258Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.3,442.08,372,408.43a3.28,3.28,0,0,1,0-5.67h0a3.26,3.26,0,0,1,3.28,0l58.29,33.65a3.28,3.28,0,0,1-.38,5.86h0A3.29,3.29,0,0,1,430.3,442.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M405.13,421.73c-20.86-12.05-37.83-41.44-37.83-65.53s17-33.89,37.83-21.84S443,375.8,443,399.89,426,433.77,405.13,421.73Zm0-79.55c-17.12-9.89-31.06-1.85-31.06,17.93S388,404,405.13,413.91,436.2,415.75,436.2,396,422.26,352.06,405.13,342.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "373.2 334.63 380.14 330.85 379.1 335.6 373.2 334.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M425.44,427.86c.17-.08,7.58-4.22,7.58-4.22l-5.73-.92Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 400.31,
    cy: 380.72,
    rx: 28.13,
    ry: 48.72,
    transform: "translate(-136.73 251.17) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M400.31,424.41c-20.86-12.05-37.84-41.44-37.84-65.53s17-33.89,37.84-21.84,37.83,41.44,37.83,65.53S421.17,436.45,400.31,424.41Zm0-79.55c-17.13-9.89-31.06-1.85-31.06,17.93s13.93,43.91,31.06,53.8,31.06,1.84,31.06-17.93S417.44,354.74,400.31,344.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M400.31,407.79c-12.93-7.47-23.44-25.68-23.44-40.6s10.51-21,23.44-13.53,23.44,25.67,23.44,40.59S413.23,415.25,400.31,407.79Zm0-46.31c-9.19-5.31-16.67-1-16.67,9.62s7.48,23.56,16.67,28.87S417,401,417,390.34,409.5,366.78,400.31,361.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M400.31,391.43c-5.11-3-9.27-10.16-9.27-16.06s4.16-8.3,9.27-5.35,9.27,10.15,9.27,16.05S405.42,394.38,400.31,391.43Zm0-13.59c-1.38-.8-2.5-.15-2.5,1.44a5.54,5.54,0,0,0,2.5,4.33c1.38.79,2.5.15,2.5-1.45A5.51,5.51,0,0,0,400.31,377.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "335.85 417.4 332.38 417.44 343.64 412.66 337.11 416.72 335.85 417.4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 336.73,
    cy: 417.91,
    rx: 0.72,
    ry: 1.25,
    transform: "translate(-163.85 224.37) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 400.47,
    cy: 381.04,
    rx: 0.72,
    ry: 1.25,
    transform: "translate(-136.87 251.3) rotate(-30)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "338.22 422.42 337.39 418.97 346.45 413.19 346.06 414.01 338.22 422.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M337.39,419c.08-.07,63.71-36.85,63.71-36.85l-1.17-2.2L336.1,416.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Girl_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-21",
    d: "M278.66,1.33C279.51,0,286-.94,288.17,4.58c.82,2.1.69,7.45,1.37,10.81s2.28,5.27,2.86,8-.36,7.3-6.94,8.11-11.63-1.5-13.19-3.6-1.58-6.55,0-8.94,2.84-4.34,2.8-7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-21",
    d: "M283,.38S278.05-1,275.07,1.61A7.31,7.31,0,0,0,273,8.89c.39,1.55,1.19,3.66,2.42,3.78S283,.38,283,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_3",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-22",
    d: "M284.84,13.76s-.33,5.47-.23,5.88,2.15.79,2.73,1.27-3,6-4.78,6.84-7.4-1.27-7.78-4.05c-.36-2.56,1.6-4.55,2.35-5.25a14.68,14.68,0,0,1,1.54,0l.16-2.65C281.28,15,284.84,13.76,284.84,13.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_4",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-22",
    d: "M268.74,43a28.69,28.69,0,0,1-5.45,5.67,26.9,26.9,0,0,0-1.86,2.15,8.22,8.22,0,0,1-3.66,2.43c-1.24.32-1.76.24-2,0s-.11-.58.42-.79a6.94,6.94,0,0,0,2.4-1.3s-1.15.54-1.87.79a7.39,7.39,0,0,1-2,.4c-.68,0-1.39-.79-.85-1s1-.26,2.09-.65a6.77,6.77,0,0,0,1.59-.81,14.78,14.78,0,0,1-2.26.46,3.44,3.44,0,0,1-1.88-.22c-.32-.13-.59-.71.12-.9a10.75,10.75,0,0,0,2.71-.63c.84-.38,1.36-.78,1.18-.86s-.66.18-1.5.12-1.62-.6-1.61-1,.18-.2,1-.27A18.64,18.64,0,0,1,258,46a8.4,8.4,0,0,0,2.6-.31c.9-.27,2.89-2.67,4.43-4.87a32.1,32.1,0,0,0,3.92-7.94c.92-3,2-8.7,2.8-10.67s2.13-2.87,3.42-2.91c1.51,0,2.15,1.94,1.75,3.65C276.19,26,272.84,37.58,268.74,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-18",
    d: "M285.59,20.17c1.53.23,3.29,1.06,3.53,1.9a18.19,18.19,0,0,1-.44,9.13c-1.33,3.52-2.83,9.87-3.6,11.39a17.91,17.91,0,0,1-11.45-2.24s-.32-6.12-.35-8.14c-4.94-4.32-.71-9.64,3.48-13.78a9.53,9.53,0,0,1,1.51,0s-3.74,4.43-1.14,6.94C282.7,23.67,283.81,21.16,285.59,20.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-22",
    d: "M274.62,7h0c.55-3.51,3.09-6.16,6.71-5.95a7,7,0,0,1,3.51,12.73,7.08,7.08,0,0,1-.56,1.54c-1.29,1.5-4.7,2.44-5.82,2.46s-1.81-.9-2.73-2.41C273.83,12.21,274.31,8.72,274.62,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M282.46,1.09c2.54.5,4.63,1.21,5.32,3.71.47,1.72,1.09,5,.5,6.38l-.36,1-3.08,1.58s-1.44-1.19-1-4.7a2.49,2.49,0,0,0-.43-1.33A3.57,3.57,0,0,1,283,6.67a4,4,0,0,0-2-2.16,6.83,6.83,0,0,0-6.11.29A6.68,6.68,0,0,1,282.46,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M268.46,85.22c-1.29,1-3.29.32-3.39.42a55.26,55.26,0,0,1-4.71,3.6c-.8.63-2.05,1.47-1.83,2.69.41,2.16,3.88,1.5,5.19.83s2.38-1.76,3.62-2.53c.88-.55,1.75-.83,1.89-2A7.13,7.13,0,0,0,268.46,85.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M269.21,87.83c-.17,1.07-1,1.36-1.91,1.91-1.25.78-2.36,1.91-3.67,2.57s-4.23,1.22-5.08-.32c.46,2.09,3.87,1.43,5.17.77s2.38-1.76,3.62-2.53c.88-.55,1.75-.83,1.89-2A2.52,2.52,0,0,0,269.21,87.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M262.19,81.7c-1.18,1-3,.42-3.05.51a46.14,46.14,0,0,1-4.31,3.28c-.73.58-1.88,1.36-1.67,2.47.37,2,3.55,1.37,4.75.76s2.18-1.61,3.31-2.32c.81-.5,1.61-.76,1.74-1.78A7,7,0,0,0,262.19,81.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M262.94,84.21c-.15,1-.94,1.25-1.74,1.74-1.16.72-2.17,1.75-3.37,2.36s-3.87,1.12-4.65-.3c.42,1.92,3.54,1.31,4.73.71s2.18-1.61,3.31-2.32c.81-.5,1.61-.76,1.74-1.78A2.08,2.08,0,0,0,262.94,84.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M280,43.94a19.14,19.14,0,0,1-10.26-1.48c.06,1.08.12,2,.12,2-4.17,3-12.55,7.92-13.09,11.34.54,10.82,2.19,26.28,2.66,26.51,1.31.62,2.22.52,2.84-.11,0,0,2.63-9.17,1.86-22.62,0,0,14.6-6.46,15.55-10a11.08,11.08,0,0,0,.4-4.4C280.08,44.8,280.05,44.37,280,43.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M284.85,42.53A15.6,15.6,0,0,1,276,43.71c0,1.45.2,4.17.2,4.17-4.17,2.95-12.54,7.92-13.09,11.34.55,10.83,1.56,26.5,2,26.7a3.54,3.54,0,0,0,3.46-.41s2.63-9.05,1.87-22.5c0-.26,12.51-6.42,14.09-8s1.9-4.05,1.86-6.35A15.49,15.49,0,0,0,284.85,42.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M287.92,44.83s4.62,8.19-3.09,12.4c-8.14,4.45-13.09,5.49-13.09,5.49l-1.22.29a31.5,31.5,0,0,1,0,8.51s-5.81,2-13.21-4.49l-2.45-7.9L254.55,57a4.4,4.4,0,0,1,1.23-4c1.78-1.61,7.41-5.73,10.91-8.09s6.3-4.62,6.3-4.62l.61-.57s4.15,3.31,11.74,2.2A12.22,12.22,0,0,1,287.92,44.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_7",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-22",
    d: "M283.33,57a22,22,0,0,1,2.24-1.77,8.9,8.9,0,0,0,2.25-1.61c.71-.71,1.76-3.68,2.31-6.58a28.91,28.91,0,0,0-.17-9.78A68,68,0,0,0,286.09,26c-1-2.18-.45-3.5.49-4.47,1.1-1.13,2.25-1.1,3.56,1.94a62.1,62.1,0,0,1,4.07,13.24,29.25,29.25,0,0,1-.14,10,36.54,36.54,0,0,1-2.65,8.37c-.34.78-.4,1.44-.87,3a10.14,10.14,0,0,1-2.39,4.2c-1,.93-1.51,1.11-1.79,1s-.32-.51.09-1a8.53,8.53,0,0,0,1.68-2.45s-.84,1.09-1.4,1.7a8,8,0,0,1-1.7,1.4c-.61.37-1.57-.06-1.17-.55s.84-.77,1.66-1.68a8,8,0,0,0,1.13-1.59,15.08,15.08,0,0,1-1.88,1.59,3.46,3.46,0,0,1-1.8.74c-.34,0-.81-.4-.24-.94a12.27,12.27,0,0,0,2.23-2c.62-.79.94-1.43.74-1.42s-.53.51-1.32.87-1.71.24-1.87-.2S282.61,57.47,283.33,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M292.16,27.56s-2.8,2.49-5.92,2L285,24.32s-.82-2.75,1.53-3.79S291.15,22.22,292.16,27.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M276.76,18.43s-3-.92-6.26,5.8l1.2.73A50.65,50.65,0,0,1,276.76,18.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_",
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_2",
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-18",
    d: "M255.79,47.45l10.82-6.24a.62.62,0,0,1,.62,0l19,10.95-11.13,6.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M275.36,56.12l.83.47c.07,0,.06.11,0,.16l-.79.45a.27.27,0,0,1-.26,0l-.83-.48c-.07,0-.06-.1,0-.15l.79-.45A.27.27,0,0,1,275.36,56.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M274.19,55.44l.83.48c.07,0,.06.1,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.07,0-.06-.11,0-.15l.79-.46A.3.3,0,0,1,274.19,55.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M273,54.76l.82.47c.07,0,.06.11,0,.16l-.79.45a.27.27,0,0,1-.26,0l-.83-.48c-.06,0-.06-.1,0-.15l.79-.45A.29.29,0,0,1,273,54.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M271.85,54.09l.83.48c.06,0,.05.1,0,.15l-.79.45a.29.29,0,0,1-.27,0l-.82-.47c-.07,0-.06-.11,0-.16l.79-.45A.29.29,0,0,1,271.85,54.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M270.68,53.41l.82.48c.07,0,.06.11,0,.15l-.79.46a.32.32,0,0,1-.27,0L269.6,54c-.06,0-.05-.11,0-.15l.79-.46A.32.32,0,0,1,270.68,53.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M269.51,52.74l.82.47c.07,0,.06.11,0,.15l-.79.46a.27.27,0,0,1-.26,0l-.83-.48c-.06,0-.06-.1,0-.15l.79-.45A.29.29,0,0,1,269.51,52.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M268.33,52.06l.83.48c.07,0,.06.1,0,.15l-.79.45a.3.3,0,0,1-.26,0l-.83-.48c-.06,0-.06-.11,0-.15l.79-.46A.27.27,0,0,1,268.33,52.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M267.16,51.38l.83.48c.07,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.07,0-.06-.11,0-.15l.79-.46A.3.3,0,0,1,267.16,51.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M266,50.71l.83.47c.07,0,.06.11,0,.16l-.79.45a.27.27,0,0,1-.26,0l-.83-.47c-.07,0-.06-.11,0-.16l.79-.45A.27.27,0,0,1,266,50.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M264.82,50l.83.48c.07,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.07,0-.06-.11,0-.15l.79-.46A.3.3,0,0,1,264.82,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M263.65,49.35l.83.48c.06,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.07,0-.06-.1,0-.15l.79-.45A.3.3,0,0,1,263.65,49.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M262.48,48.68l.83.48c.06,0,.05.1,0,.15l-.79.45a.29.29,0,0,1-.27,0l-.82-.47c-.07,0-.06-.11,0-.16l.78-.45A.29.29,0,0,1,262.48,48.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M261.31,48l.82.48c.07,0,.06.11,0,.15l-.79.46a.32.32,0,0,1-.27,0l-.82-.48c-.07,0-.06-.11,0-.15L261,48A.32.32,0,0,1,261.31,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M259.57,47l1.39.8c.07,0,.06.11,0,.16l-.79.45a.27.27,0,0,1-.26,0l-1.39-.8c-.07,0-.06-.11,0-.15l.79-.46A.3.3,0,0,1,259.57,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M274.76,54.46l.83.48c.06,0,.06.1,0,.15l-.79.45a.29.29,0,0,1-.27,0l-.82-.47c-.07,0-.06-.11,0-.16l.79-.45A.27.27,0,0,1,274.76,54.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M273.59,53.78l.82.48c.07,0,.06.1,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.06,0-.05-.11,0-.15l.79-.46A.32.32,0,0,1,273.59,53.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M272.41,53.1l.83.48c.07,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.07,0-.06-.11,0-.15l.79-.46A.3.3,0,0,1,272.41,53.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M271.24,52.43l.83.47c.06,0,.06.11,0,.16l-.79.45a.27.27,0,0,1-.26,0l-.83-.48c-.07,0-.06-.1,0-.15l.79-.45A.27.27,0,0,1,271.24,52.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M270.08,51.75l.82.48c.07,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.06,0-.05-.1,0-.15l.79-.46A.32.32,0,0,1,270.08,51.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M268.9,51.08l.83.47c.07,0,.06.11,0,.16l-.79.45a.27.27,0,0,1-.26,0l-.83-.47c-.07,0-.06-.11,0-.16l.79-.45A.27.27,0,0,1,268.9,51.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M267.73,50.4l.83.48c.06,0,.06.1,0,.15l-.79.45a.3.3,0,0,1-.26,0l-.83-.48c-.07,0-.06-.11,0-.15l.79-.46A.27.27,0,0,1,267.73,50.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M266.56,49.72l.82.48c.07,0,.06.11,0,.15l-.78.46a.32.32,0,0,1-.27,0l-.83-.48c-.06,0-.05-.11,0-.15l.79-.46A.32.32,0,0,1,266.56,49.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M265.38,49l.83.48c.07,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.07,0-.06-.1,0-.15l.79-.45A.3.3,0,0,1,265.38,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M264.21,48.37l.83.47c.06,0,.06.11,0,.16l-.79.45a.27.27,0,0,1-.26,0l-.83-.47c-.07,0-.06-.11,0-.16l.79-.45A.27.27,0,0,1,264.21,48.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M263,47.69l.82.48c.07,0,.06.1,0,.15l-.78.46a.36.36,0,0,1-.27,0l-.83-.48c-.06,0,0-.11,0-.15l.79-.46A.32.32,0,0,1,263,47.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M261.86,47l.83.48c.07,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.07,0-.06-.11,0-.15l.79-.46A.3.3,0,0,1,261.86,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M275.93,55.13l1.39.81c.07,0,.06.11,0,.15l-.78.46a.32.32,0,0,1-.27,0l-1.39-.81c-.07,0-.06-.1,0-.15l.79-.45A.3.3,0,0,1,275.93,55.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M259.63,47l.83.47a.25.25,0,0,0,.24,0l.84-.48a.08.08,0,0,0,0-.14l-.07,0c-.06,0-.06-.09,0-.13l.88-.51c.07,0,.07-.1,0-.14l-.52-.3a.28.28,0,0,0-.25,0l-.82.47-.17.1-.13.07-.12.07-.71.41A.08.08,0,0,0,259.63,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M279.9,53.49l.82.48c.07,0,.06.11,0,.15l-.79.46a.32.32,0,0,1-.27,0l-.82-.48c-.07,0-.06-.11,0-.15l.79-.46A.32.32,0,0,1,279.9,53.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M278.73,52.82l.83.48c.06,0,.06.1,0,.15l-.79.45a.27.27,0,0,1-.26,0l-.83-.47c-.07,0-.06-.11,0-.16l.79-.45A.27.27,0,0,1,278.73,52.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M277.56,52.14l.83.48c.07,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.07,0-.06-.11,0-.15l.79-.46A.3.3,0,0,1,277.56,52.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M267.62,46.4l.82.48c.07,0,.06.11,0,.15l-.78.46a.32.32,0,0,1-.27,0l-.83-.48c-.06,0-.05-.11,0-.15l.79-.46A.32.32,0,0,1,267.62,46.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M266.45,45.73l.83.47c.06,0,.05.11,0,.16l-.79.45a.29.29,0,0,1-.27,0l-.82-.47c-.07,0-.06-.11,0-.16l.78-.45A.29.29,0,0,1,266.45,45.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M265.28,45.05l.83.48c.07,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.07,0-.06-.11,0-.15l.79-.46A.3.3,0,0,1,265.28,45.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M264.11,44.38l.83.48c.07,0,.06.1,0,.15l-.79.45a.27.27,0,0,1-.26,0L263,45c-.07,0-.06-.11,0-.15l.79-.46A.27.27,0,0,1,264.11,44.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M276.09,51.3l1.13.65c.07,0,.06.1,0,.15l-.79.45a.3.3,0,0,1-.26,0L275,51.91c-.07,0-.06-.1,0-.15l.79-.45A.27.27,0,0,1,276.09,51.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M268.78,47.08l1.13.65c.07,0,.06.1,0,.15l-.79.45a.3.3,0,0,1-.26,0l-1.13-.66c-.07,0-.06-.1,0-.15l.79-.45A.27.27,0,0,1,268.78,47.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M270.25,47.92l5.5,3.18c.07,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-5.5-3.18c-.07,0-.06-.1,0-.15l.79-.46A.3.3,0,0,1,270.25,47.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M275.58,53.62l.82.48c.07,0,.06.1,0,.15l-.79.45a.27.27,0,0,1-.26,0l-.83-.47c-.06,0-.05-.11,0-.16l.79-.45A.29.29,0,0,1,275.58,53.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M274.41,52.94l.82.48c.07,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.06,0-.05-.11,0-.15l.79-.46A.32.32,0,0,1,274.41,52.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M273.24,52.27l.82.48c.07,0,.06.1,0,.15l-.79.45a.27.27,0,0,1-.26,0l-.83-.47c-.06,0-.05-.11,0-.16l.79-.45A.29.29,0,0,1,273.24,52.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M272.07,51.59l.82.48c.07,0,.06.11,0,.15l-.78.46a.32.32,0,0,1-.27,0l-.83-.48c-.06,0-.05-.11,0-.15l.79-.46A.32.32,0,0,1,272.07,51.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M270.9,50.92l.82.47c.07,0,.06.11,0,.16l-.78.45a.29.29,0,0,1-.27,0l-.83-.47c-.06,0-.05-.11,0-.16l.79-.45A.29.29,0,0,1,270.9,50.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M269.73,50.24l.82.48c.07,0,.06.11,0,.15l-.78.46a.32.32,0,0,1-.27,0l-.83-.48c-.06,0,0-.11,0-.15l.79-.46A.32.32,0,0,1,269.73,50.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M268.56,49.57l.82.47c.07,0,.06.11,0,.16l-.78.45a.29.29,0,0,1-.27,0l-.83-.48c-.06,0-.05-.1,0-.15l.79-.45A.29.29,0,0,1,268.56,49.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M267.39,48.89l.82.48c.07,0,.06.1,0,.15l-.79.46a.32.32,0,0,1-.27,0l-.83-.48c-.06,0-.05-.11,0-.15l.79-.46A.32.32,0,0,1,267.39,48.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M266.22,48.21l.82.48c.07,0,.06.11,0,.15l-.79.46a.29.29,0,0,1-.27,0l-.82-.48c-.07,0-.06-.1,0-.15l.79-.45A.32.32,0,0,1,266.22,48.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M265.05,47.54l.82.48c.07,0,.06.1,0,.15l-.79.45a.32.32,0,0,1-.27,0l-.82-.48c-.07,0-.06-.11,0-.15l.79-.46A.32.32,0,0,1,265.05,47.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M263.88,46.86l.82.48c.07,0,.06.11,0,.15l-.79.46a.32.32,0,0,1-.27,0l-.82-.48c-.07,0-.06-.1,0-.15l.79-.46A.32.32,0,0,1,263.88,46.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M262.71,46.19l.82.48c.07,0,.06.1,0,.15l-.79.45a.29.29,0,0,1-.27,0l-.82-.47c-.07,0-.06-.11,0-.15l.79-.46A.29.29,0,0,1,262.71,46.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M276.75,54.29l1.71,1c.06,0,.06.11,0,.15l-.79.46a.32.32,0,0,1-.27,0l-1.71-1c-.06,0-.06-.1,0-.15l.79-.46A.32.32,0,0,1,276.75,54.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M277.29,53.3l.83.48c.07,0,.06.1,0,.15l-.79.45a.27.27,0,0,1-.26,0l-.83-.47c-.07,0-.06-.11,0-.16l.79-.45A.27.27,0,0,1,277.29,53.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M276.12,52.62l.83.48c.07,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.07,0-.06-.11,0-.15l.79-.46A.3.3,0,0,1,276.12,52.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M275,52l.83.48c.07,0,.06.1,0,.15L275,53a.27.27,0,0,1-.26,0l-.83-.47c-.07,0-.06-.11,0-.16l.79-.45A.27.27,0,0,1,275,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M273.78,51.27l.83.48c.07,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.07,0-.06-.11,0-.15l.79-.46A.3.3,0,0,1,273.78,51.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M272.61,50.6l.83.47c.07,0,.06.11,0,.16l-.79.45a.27.27,0,0,1-.26,0l-.83-.47c-.07,0-.06-.11,0-.16l.79-.45A.27.27,0,0,1,272.61,50.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M271.44,49.92l.83.48c.07,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.07,0-.06-.11,0-.15l.79-.46A.3.3,0,0,1,271.44,49.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M270.27,49.25l.83.47c.07,0,.06.11,0,.16l-.79.45a.27.27,0,0,1-.26,0l-.83-.48c-.07,0-.06-.1,0-.15l.79-.45A.27.27,0,0,1,270.27,49.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M269.1,48.57l.83.48c.07,0,.06.11,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.07,0-.06-.11,0-.15l.79-.46A.3.3,0,0,1,269.1,48.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M267.93,47.9l.83.47c.07,0,.06.11,0,.16L268,49a.27.27,0,0,1-.26,0l-.83-.48c-.07,0-.06-.1,0-.15l.79-.45A.27.27,0,0,1,267.93,47.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M266.76,47.22l.83.48c.07,0,.06.1,0,.15l-.79.46a.3.3,0,0,1-.26,0l-.83-.48c-.06,0-.06-.11,0-.15l.79-.46A.3.3,0,0,1,266.76,47.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M265.59,46.54l.83.48c.07,0,.06.11,0,.15l-.79.46a.27.27,0,0,1-.26,0l-.83-.48c-.06,0-.06-.1,0-.15l.79-.45A.3.3,0,0,1,265.59,46.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M263,45l2.27,1.32c.07,0,.06.1,0,.15l-.79.46a.3.3,0,0,1-.26,0l-2.27-1.32c-.07,0-.06-.1,0-.15l.79-.46A.32.32,0,0,1,263,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M278.46,54l1.13.65c.07,0,.06.11,0,.16l-.79.45a.27.27,0,0,1-.26,0l-1.13-.65c-.07,0-.06-.1,0-.15l.79-.46A.3.3,0,0,1,278.46,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M258.4,47.68,275,57.27c.07,0,.06.11,0,.15l-.39.23a.32.32,0,0,1-.27,0l-16.61-9.59c-.07,0-.06-.11,0-.15l.39-.23A.29.29,0,0,1,258.4,47.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_9",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-27",
    points: "278.05 48.31 277.94 48.37 275.08 50.02 270 47.09 269.89 47.02 272.86 45.31 278.05 48.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_10",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-28",
    points: "277.94 48.37 275.08 50.02 270 47.09 272.86 45.43 277.94 48.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-28",
    d: "M286.21,52.16v.26a1,1,0,0,1-.52.9L275.6,59.14a1,1,0,0,1-1,0L256.32,48.61a1,1,0,0,1-.53-.9v-.26l19.29,11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-28",
    d: "M275.08,58.59v.69a1.07,1.07,0,0,1-.52-.14L256.32,48.61a1,1,0,0,1-.53-.9v-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_13",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-18",
    d: "M274.79,58.74a1.26,1.26,0,0,1-1.07-.08L255.56,48.17a1.22,1.22,0,0,1-.6-.86l-2-11.86a1.5,1.5,0,0,1,0-.2,1.22,1.22,0,0,1,.37-.88l18.87,10.9a.93.93,0,0,1,.45.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_14",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-28",
    d: "M275.08,58.59l-.12.07-.17.08-2.15-12.83a.93.93,0,0,0-.45-.64l-18.87-10.9a.92.92,0,0,1,.25-.19L272.48,45.1a.91.91,0,0,1,.45.64Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "46.21 364.33 25.95 352.63 46.21 340.93 66.47 352.63 46.21 364.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "78.32 345.58 58.06 333.89 78.32 322.19 98.58 333.89 78.32 345.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "90.35 263.34 70.09 251.64 90.35 239.94 110.61 251.64 90.35 263.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "90.35 338.81 70.09 327.11 70.09 251.64 90.35 263.34 90.35 338.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "90.35 338.81 70.09 327.11 70.09 251.64 90.35 263.34 90.35 338.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "110.61 327.11 90.35 338.81 90.35 263.34 110.61 251.64 110.61 327.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "110.61 327.11 90.35 338.81 90.35 263.34 110.61 251.64 110.61 327.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "59.96 301.76 39.7 290.06 59.96 278.37 80.22 290.06 59.96 301.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "59.96 356.26 39.7 344.56 39.7 290.06 59.96 301.76 59.96 356.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "59.96 356.26 39.7 344.56 39.7 290.06 59.96 301.76 59.96 356.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "80.22 344.56 59.96 356.26 59.96 301.76 80.22 290.06 80.22 344.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "80.22 344.56 59.96 356.26 59.96 301.76 80.22 290.06 80.22 344.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "20.26 379.66 0 367.96 20.26 356.26 40.52 367.96 20.26 379.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "27.6 341.71 7.34 330.01 27.6 318.32 47.86 330.01 27.6 341.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "27.6 375.24 7.34 363.55 7.34 330.01 27.6 341.71 27.6 375.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "27.6 375.24 7.34 363.55 7.34 330.01 27.6 341.71 27.6 375.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "47.86 363.55 27.6 375.24 27.6 341.71 47.86 330.01 47.86 363.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "47.86 363.55 27.6 375.24 27.6 341.71 47.86 330.01 47.86 363.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.3,453.74l-13-18.72L217,432.2a65.37,65.37,0,0,0-14.58-1.68c-5.87,5.92-42.89,7.5-57.59.2-16.67-8.28-25.41-18.39-28.13-24.58-4.84-11,4.39-23.93,4.39-23.93-25.22,14.56-25.22,38.26,0,52.82,23.64,13.65,61.18,14.5,86.56,2.56h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "307.55 500 220.25 449.6 235.08 441.04 322.38 491.44 307.55 500"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.21,430.42c-25.22-14.56-25.22-38.25,0-52.81s66.26-14.56,91.48,0,25.22,38.25,0,52.81S149.43,445,124.21,430.42Zm80.32-46.37c-19.07-11-50.1-11-69.16,0S116.3,413,135.37,424s50.09,11,69.16,0S223.6,395.06,204.53,384.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.33 405.13 105.33 393.94 116.67 399.53 105.33 405.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.44,423.58c.46.57,2.08,11.53,34.38,11.53s30.92-12.95,30.92-12.95-30.46,4.19-30.92,4.19S137.44,423.58,137.44,423.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "234.6 393.94 234.6 404.01 225.3 398.08 234.6 393.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.55,369.58a83.11,83.11,0,0,1,29.4-5.65A70.55,70.55,0,0,1,198.36,370l-2.05,3.41h-54Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 169.96,
    cy: 397.81,
    rx: 48.15,
    ry: 27.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.21,420.35c-25.22-14.56-25.22-38.26,0-52.82s66.26-14.56,91.48,0,25.22,38.26,0,52.82S149.43,434.91,124.21,420.35ZM204.53,374c-19.07-11-50.1-11-69.16,0s-19.07,28.93,0,39.94,50.09,11,69.16,0S223.6,385,204.53,374Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "230.79 436.31 208.91 423.58 221.62 416.25 243.5 428.97 230.79 436.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "230.79 446.45 208.93 433.8 208.93 423.59 230.79 436.24 230.79 446.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "310.32 498.24 223.03 447.84 223.03 430.72 310.32 481.12 310.32 498.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "310.33 481.13 223.03 430.73 237.86 422.17 325.16 472.56 310.33 481.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M310.32,498.24c.9-.1,14.84-8.35,14.84-8.35V472.56l-14.83,8.57Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Men_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_15",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-22",
    d: "M61.78,272.5a36.55,36.55,0,0,0,5.32,7.25c.58.67,5-1,4.08-1.5s-3.83-4.52-5.28-7.21a91.19,91.19,0,0,1-3.1-9.85c-.91-3.3-1.7-8.14-2.36-10.42a4.47,4.47,0,0,0-3.39-3.45c-1.6-.37-2.63.07-2.34,2C55.22,252.7,57.87,265.85,61.78,272.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M59.24,324c1.37,1.12,3.4.1,3.5.2a60.16,60.16,0,0,0,5.06,4.22c.86.67,2.2,1.57,2,2.87-.43,2.31-4.13,1.6-5.53.89s-2.54-1.88-3.86-2.7c-.94-.59-1.87-.89-2-2.08C58.25,326.69,59,324,59.24,324Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M58.36,326.93c.18,1.14,1.1,1.45,2,2,1.35.83,2.53,2,3.93,2.74s4.51,1.31,5.41-.35c-.49,2.23-4.13,1.53-5.51.83s-2.54-1.88-3.86-2.7c-.94-.59-1.87-.89-2-2.08A2.07,2.07,0,0,1,58.36,326.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M73.16,316c1.38,1.12,3.78-.1,3.88,0a54.81,54.81,0,0,0,4.53,4.09c.85.67,2.19,1.57,2,2.86-.43,2.32-4.14,1.61-5.54.9s-2.54-1.88-3.86-2.7c-.94-.59-1.87-.89-2-2.08A6.41,6.41,0,0,1,73.16,316Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M72.14,318.74c.19,1.14,1.1,1.45,2,2,1.34.83,2.53,2,3.92,2.74s4.52,1.31,5.42-.35C83,325.4,79.39,324.7,78,324s-2.54-1.88-3.86-2.7c-1-.59-1.88-.89-2-2.08A2,2,0,0,1,72.14,318.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_16",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-25",
    d: "M40.88,280c-1.52,9.51,2.7,13.05,8.19,15.08,3.94,1.45,9.59,3.68,9.59,3.68s-.08,2.09-.12,6.77c0,4.13.5,19.18.5,19.18a4.59,4.59,0,0,0,4.2,0s2.22-11.54,2.69-16.74c.63-7.05,1.72-11.67,1.36-13.19-.32-1.34-8-5.13-10.48-7.16L73,293a28.14,28.14,0,0,0-.47,5.31c.15,5.6.45,17.71.45,17.71s2.22,1.6,4.11,0c0,0,4.06-24,3.57-27.16-.47-3-14.7-9.17-17.21-11.29a4,4,0,0,0-3.16-.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_3",
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_4",
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_17",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-18",
    d: "M79.61,284l-10.85-6.27a.64.64,0,0,0-.63,0l-19,11,11.17,6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M59.75,292.83l-.82.48c-.07,0-.06.1,0,.15l.79.45a.29.29,0,0,0,.27,0l.82-.47c.07,0,.06-.11,0-.16l-.79-.45A.29.29,0,0,0,59.75,292.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M60.92,292.15l-.82.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.06,0,0-.11,0-.15l-.79-.46A.32.32,0,0,0,60.92,292.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M62.11,291.47l-.83.48c-.07,0-.06.1,0,.15l.79.45a.27.27,0,0,0,.26,0l.83-.47c.07,0,.06-.11,0-.16l-.79-.45A.27.27,0,0,0,62.11,291.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M63.27,290.8l-.83.48c-.07,0-.06.1,0,.15l.79.45a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,63.27,290.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M64.44,290.12l-.83.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,64.44,290.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M65.61,289.45l-.83.47c-.07,0-.06.11,0,.16l.79.45a.27.27,0,0,0,.26,0l.83-.47c.07,0,.06-.11,0-.16l-.79-.45A.27.27,0,0,0,65.61,289.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M66.78,288.77l-.83.48c-.06,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,66.78,288.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M68,288.09l-.83.48c-.06,0-.06.11,0,.15l.79.46a.29.29,0,0,0,.27,0l.82-.48c.07,0,.06-.1,0-.15l-.79-.45A.3.3,0,0,0,68,288.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M69.12,287.42l-.82.48c-.07,0-.06.1,0,.15l.79.45a.29.29,0,0,0,.27,0l.82-.47c.07,0,.06-.11,0-.15l-.79-.46A.29.29,0,0,0,69.12,287.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M70.29,286.74l-.82.48c-.07,0-.06.11,0,.15l.78.46a.32.32,0,0,0,.27,0l.83-.48c.06,0,0-.11,0-.15l-.79-.46A.32.32,0,0,0,70.29,286.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M71.46,286.07l-.82.47c-.07,0-.06.11,0,.16l.79.45a.27.27,0,0,0,.26,0l.83-.48c.06,0,.06-.1,0-.15l-.79-.45A.29.29,0,0,0,71.46,286.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M72.64,285.39l-.83.48c-.07,0-.06.1,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,72.64,285.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M73.81,284.71l-.83.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.1,0-.15l-.79-.46A.3.3,0,0,0,73.81,284.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M75.54,283.71l-1.39.81c-.07,0-.06.1,0,.15l.79.45a.27.27,0,0,0,.26,0l1.39-.8c.07,0,.06-.11,0-.15l-.79-.46A.32.32,0,0,0,75.54,283.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M60.36,291.17l-.83.48c-.07,0-.06.1,0,.15l.79.46a.34.34,0,0,0,.26,0l.83-.48c.06,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,60.36,291.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M61.53,290.49l-.83.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,61.53,290.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M62.7,289.81l-.83.48c-.06,0,0,.11,0,.15l.79.46a.29.29,0,0,0,.27,0l.82-.48c.07,0,.06-.1,0-.15l-.79-.45A.3.3,0,0,0,62.7,289.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M63.87,289.14l-.82.48c-.07,0-.06.1,0,.15l.79.45a.27.27,0,0,0,.26,0l.83-.47c.06,0,.06-.11,0-.16l-.79-.45A.29.29,0,0,0,63.87,289.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M65,288.47l-.83.47c-.07,0-.06.11,0,.16l.79.45a.27.27,0,0,0,.26,0l.83-.48c.07,0,.06-.1,0-.15l-.79-.45A.27.27,0,0,0,65,288.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M66.21,287.79l-.83.48c-.06,0,0,.1,0,.15l.79.45a.29.29,0,0,0,.27,0l.82-.47c.07,0,.06-.11,0-.16l-.78-.45A.29.29,0,0,0,66.21,287.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M67.38,287.11l-.82.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.06,0,.06-.11,0-.15l-.79-.46A.32.32,0,0,0,67.38,287.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M68.56,286.43l-.83.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.1,0-.15l-.79-.46A.3.3,0,0,0,68.56,286.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M69.73,285.76l-.83.47c-.06,0-.05.11,0,.16l.79.45a.29.29,0,0,0,.27,0l.82-.48c.07,0,.06-.1,0-.15l-.79-.45A.27.27,0,0,0,69.73,285.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M70.9,285.08l-.82.48c-.07,0-.06.1,0,.15l.79.45a.3.3,0,0,0,.26,0l.83-.48c.06,0,.06-.11,0-.15l-.79-.46A.29.29,0,0,0,70.9,285.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M72.08,284.4l-.83.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,72.08,284.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M73.25,283.72l-.83.48c-.06,0-.06.11,0,.15l.79.46a.32.32,0,0,0,.27,0l.82-.48c.07,0,.06-.1,0-.15l-.79-.46A.34.34,0,0,0,73.25,283.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M59.18,291.85l-1.39.8c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l1.39-.8c.07,0,.06-.11,0-.16l-.78-.45A.29.29,0,0,0,59.18,291.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M75.49,283.67l-.83.48a.31.31,0,0,1-.25,0l-.83-.49c-.07,0-.07-.1,0-.14l.06,0c.07,0,.07-.09,0-.13l-.88-.51c-.07,0-.07-.1,0-.14l.53-.3a.25.25,0,0,1,.24,0l.83.48.17.09.12.07.12.08.72.41A.08.08,0,0,1,75.49,283.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M55.22,290.2l-.83.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.1,0-.15l-.79-.46A.3.3,0,0,0,55.22,290.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M56.38,289.53l-.82.48c-.07,0-.06.1,0,.15l.79.45a.3.3,0,0,0,.26,0l.83-.48c.06,0,.06-.11,0-.15l-.79-.46A.32.32,0,0,0,56.38,289.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M57.55,288.86l-.82.47c-.07,0-.06.11,0,.15l.79.46a.29.29,0,0,0,.27,0l.82-.48c.07,0,.06-.1,0-.15l-.79-.45A.29.29,0,0,0,57.55,288.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M67.5,283.11l-.83.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,67.5,283.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M68.67,282.44l-.83.48c-.07,0-.06.1,0,.15l.79.45a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.27.27,0,0,0,68.67,282.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M69.83,281.76l-.82.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.06,0,0-.1,0-.15l-.79-.45A.32.32,0,0,0,69.83,281.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M71,281.09l-.83.48c-.06,0,0,.1,0,.15l.79.46a.32.32,0,0,0,.27,0l.82-.48c.07,0,.06-.11,0-.15l-.78-.46A.32.32,0,0,0,71,281.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M59,288l-1.13.65c-.06,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l1.13-.65c.07,0,.06-.11,0-.16l-.79-.45A.27.27,0,0,0,59,288Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M66.33,283.79l-1.13.65c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l1.13-.65c.07,0,.06-.11,0-.16l-.79-.45A.27.27,0,0,0,66.33,283.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M64.86,284.64l-5.5,3.17c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l5.5-3.18c.07,0,.06-.1,0-.15l-.78-.45A.29.29,0,0,0,64.86,284.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M59.54,290.33l-.83.48c-.07,0-.06.1,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,59.54,290.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M60.71,289.65l-.83.48c-.07,0-.06.11,0,.15l.79.46a.27.27,0,0,0,.26,0l.83-.48c.07,0,.06-.1,0-.15l-.79-.45A.3.3,0,0,0,60.71,289.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M61.88,289l-.83.48c-.07,0-.06.1,0,.15l.79.45a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,61.88,289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M63.05,288.3l-.83.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.1,0-.15l-.79-.46A.3.3,0,0,0,63.05,288.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M64.22,287.63l-.83.48c-.07,0-.06.1,0,.15l.79.45a.27.27,0,0,0,.26,0l.83-.47c.07,0,.06-.11,0-.15l-.79-.46A.27.27,0,0,0,64.22,287.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M65.39,287l-.83.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,65.39,287Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M66.56,286.28l-.83.48c-.07,0-.06.1,0,.15l.79.45a.27.27,0,0,0,.26,0l.83-.47c.07,0,.06-.11,0-.16l-.79-.45A.27.27,0,0,0,66.56,286.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M67.73,285.6l-.83.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,67.73,285.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M68.9,284.93l-.83.47c-.07,0-.06.11,0,.16l.79.45a.27.27,0,0,0,.26,0l.83-.47c.07,0,.06-.11,0-.16l-.79-.45A.27.27,0,0,0,68.9,284.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M70.07,284.25l-.83.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,70.07,284.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M71.24,283.58l-.83.47c-.07,0-.06.11,0,.16l.79.45a.27.27,0,0,0,.26,0l.83-.48c.07,0,.06-.1,0-.15l-.79-.45A.27.27,0,0,0,71.24,283.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M72.41,282.9l-.83.48c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,72.41,282.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M58.37,291l-1.71,1c-.07,0-.06.11,0,.16l.79.45a.27.27,0,0,0,.26,0l1.71-1c.07,0,.06-.1,0-.15l-.79-.45A.27.27,0,0,0,58.37,291Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M57.82,290l-.82.48c-.07,0-.06.1,0,.15l.79.46a.32.32,0,0,0,.27,0l.82-.48c.07,0,.06-.11,0-.15l-.79-.46A.32.32,0,0,0,57.82,290Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M59,289.33l-.82.48c-.07,0-.06.11,0,.15l.79.46a.29.29,0,0,0,.27,0l.82-.48c.07,0,.06-.1,0-.15l-.79-.45A.32.32,0,0,0,59,289.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M60.16,288.66l-.83.48c-.06,0,0,.1,0,.15l.79.45a.32.32,0,0,0,.27,0l.82-.48c.07,0,.06-.11,0-.15l-.78-.46A.32.32,0,0,0,60.16,288.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M61.33,288l-.83.48c-.06,0,0,.11,0,.15l.79.46a.32.32,0,0,0,.27,0l.82-.48c.07,0,.06-.1,0-.15L61.6,288A.36.36,0,0,0,61.33,288Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M62.5,287.31l-.83.48c-.06,0-.05.1,0,.15l.79.45a.32.32,0,0,0,.27,0l.82-.48c.07,0,.06-.11,0-.15l-.79-.46A.27.27,0,0,0,62.5,287.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M63.67,286.63l-.83.48c-.06,0-.06.11,0,.15l.79.46a.32.32,0,0,0,.27,0l.82-.48c.07,0,.06-.1,0-.15l-.79-.46A.3.3,0,0,0,63.67,286.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M64.84,286l-.83.48c-.06,0-.06.1,0,.15l.79.45a.29.29,0,0,0,.27,0l.82-.47c.07,0,.06-.11,0-.16L65.1,286A.27.27,0,0,0,64.84,286Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M66,285.28l-.83.48c-.06,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,66,285.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M67.18,284.61l-.83.48c-.06,0-.06.1,0,.15l.79.45a.27.27,0,0,0,.26,0l.83-.47c.07,0,.06-.11,0-.16l-.79-.45A.27.27,0,0,0,67.18,284.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M68.35,283.93l-.83.48c-.06,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l.83-.48c.07,0,.06-.11,0-.15l-.79-.46A.3.3,0,0,0,68.35,283.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M69.52,283.26l-.83.47c-.07,0-.06.11,0,.16l.79.45a.27.27,0,0,0,.26,0l.83-.47c.07,0,.06-.11,0-.16l-.79-.45A.27.27,0,0,0,69.52,283.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M72.14,281.75l-2.28,1.31c-.07,0-.06.11,0,.15l.79.46a.3.3,0,0,0,.26,0l2.28-1.32c.07,0,.06-.1,0-.15l-.79-.45A.27.27,0,0,0,72.14,281.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M56.65,290.69l-1.13.65c-.06,0-.05.1,0,.15l.79.45a.32.32,0,0,0,.27,0l1.12-.66c.07,0,.06-.1,0-.15l-.79-.45A.29.29,0,0,0,56.65,290.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M76.72,284.39,60.11,294c-.07,0-.06.11,0,.15l.4.23a.27.27,0,0,0,.26,0l16.61-9.59c.07,0,.06-.11,0-.15l-.4-.23A.3.3,0,0,0,76.72,284.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_18",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-27",
    points: "57.28 284.82 57.39 284.88 60.26 286.54 65.36 283.59 65.47 283.53 62.49 281.81 57.28 284.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_19",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-28",
    points: "57.39 284.88 60.26 286.54 65.36 283.59 62.49 281.94 57.39 284.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_20",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-28",
    d: "M49.09,288.69v.25a1,1,0,0,0,.53.91l10.11,5.84a1.1,1.1,0,0,0,.53.14,1.07,1.07,0,0,0,.52-.14l18.31-10.57a1.05,1.05,0,0,0,.52-.91V284L60.26,295.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_21",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-18",
    d: "M60.55,295.29a1.26,1.26,0,0,0,1.07-.08l18.23-10.53a1.22,1.22,0,0,0,.6-.87l2-11.89a1.48,1.48,0,0,0,0-.21,1.25,1.25,0,0,0-.36-.88L63.15,281.77a1,1,0,0,0-.44.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_22",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-28",
    d: "M60.26,295.13l.12.08.17.08,2.16-12.88a1,1,0,0,1,.44-.64L82.1,270.83a1.24,1.24,0,0,0-.26-.19l-19,11a.9.9,0,0,0-.44.64Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_23",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-22",
    d: "M46.5,244.21s.23,4.53.13,4.93-2.08,1.73-2.65,2.2,3.13,4.13,4.93,5,7.51-1.35,7.61-4.16-1-5.16-1.85-5.28S46.5,244.21,46.5,244.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_24",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-18",
    d: "M46,249.92s3.29,4.9,7.87,5.36c1.45-1.43,1.58-6.5-.42-8.12,0,0,1.84-1.48,3.1-1.19a6.47,6.47,0,0,1,2.83,3.61A29.63,29.63,0,0,1,61,260.06c-.07,4.8,0,16.95,0,16.95A10.35,10.35,0,0,1,56.16,284a15,15,0,0,1-10.88,1.5c-2.32-.54-3.19-1.84-4-3.53.21-3.36,1.54-10.29,1-14.53s-1.45-7.39-1.69-10.82.46-3.35,2.17-4.57A27.46,27.46,0,0,1,46,249.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-22",
    d: "M51.26,288.94a22.67,22.67,0,0,0-2.57-1.47,5.33,5.33,0,0,1-2.2-1.34c-.81-.79-2.13-3.77-3.07-6.68a29.88,29.88,0,0,1-1.11-10.11c.4-4.08,1.87-9.79,2.24-12.14s-.38-3.29-1.47-4.15c-1.29-1-3.06-.57-4,2.72A63.31,63.31,0,0,0,37,269.71,31.82,31.82,0,0,0,38.56,280a37.57,37.57,0,0,0,3.93,8.09c.45.76.6,1.43,1.28,3a10.49,10.49,0,0,0,3,4c1.15.83,1.7,1,2,.79s.27-.57-.21-1a8.54,8.54,0,0,1-2.06-2.3s1,1,1.67,1.56a8.8,8.8,0,0,0,1.92,1.23c.68.3,1.61-.27,1.13-.73s-1-.67-1.92-1.51a8.17,8.17,0,0,1-1.37-1.48A15.44,15.44,0,0,0,50.05,293a3.59,3.59,0,0,0,1.94.53c.36,0,.79-.51.12-1a13.25,13.25,0,0,1-2.54-1.74c-.74-.73-1.16-1.35-1-1.36s.61.44,1.47.71,1.79,0,1.9-.44S52.07,289.34,51.26,288.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_26",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-22",
    d: "M56.75,237.46h0c-.54-3.52-3.08-6.18-6.7-6a7,7,0,0,0-3.55,12.73,6.86,6.86,0,0,0,.56,1.53c1.28,1.5,5.16,2.43,6.27,2.27a3.32,3.32,0,0,0,2.89-2.36C57.42,242.89,57,239.2,56.75,237.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M46.5,244.21h0l.33-3.07s-2.5-6.49,3.42-5.24c3.9.82,4.88,1.18,6.07-1.44s-3-5-8-4.33a6.89,6.89,0,0,0-6.16,7C42.31,239.05,42.82,243,46.5,244.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M36.37,261.81s3.23,3.21,7.05,2.29c.55-.37,1.86-7.88,1.86-7.88s0-4.17-3.19-4.06S36.37,261.81,36.37,261.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M60.76,255.58a3.56,3.56,0,0,0,2.39-1.07c-.13-1.68-2.28-8.07-6.61-8.54a7.94,7.94,0,0,1,2.7,3.26A42.12,42.12,0,0,1,60.76,255.58Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoSvg);
export default __webpack_public_path__ + "static/media/SEO_SVG.27915bc47045bf5eb36aa9f2539772fd.svg";
export { ForwardRef as ReactComponent };